import { jsx as _jsx } from "react/jsx-runtime";
export const ChevronUpS = ({ color = 'currentColor', ...props })=>/*#__PURE__*/ _jsx("svg", {
        fill: "none",
        height: "24",
        viewBox: "0 0 24 24",
        width: "24",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ _jsx("path", {
            d: "M3.22887 16.7893C2.95029 16.5188 2.92655 16.0845 3.16246 15.7864L11.4604 7.22873C11.6015 7.08326 11.7958 7.00131 11.9985 7.00119C12.2013 7.00117 12.3963 7.08319 12.5375 7.22873L20.8374 15.7864C21.0735 16.0845 21.0498 16.5188 20.771 16.7893C20.4738 17.0777 19.9989 17.0709 19.7104 16.7737L11.9985 8.82933L4.23376 16.8255C3.94283 17.0705 3.50769 17.0599 3.22887 16.7893Z",
            fill: color
        })
    });

//# sourceMappingURL=chevron-up-s.js.map